import React, { Component } from 'react';
import CardMedia from '@material-ui/core/CardMedia';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';
import { Card } from '../../components';

import Answer from './answer';

class Question extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedAnswers: Immutable({}),
    };
  }

  answerSelectionChanged(answer, event, selected) {
    let selectedAnswers = this.state.selectedAnswers;
    if (this.props.question.isSingleChoice) {
      selectedAnswers = Immutable({});
    }

    if (selected) {
      selectedAnswers = selectedAnswers.set(answer.id, true);
    } else {
      selectedAnswers = selectedAnswers.without(answer.id);
    }

    this.setState({
      selectedAnswers,
    });

    this.props.answerSelectionChanged(this.props.question, selectedAnswers);
  }

  renderQuestionImage() {
    if (!this.props.question.imageUrl) return null;
    const { classes } = this.props;

    return (
      <CardMedia>
        <div className={classes.imageContainer}>
          <img
            src={this.props.question.imageUrl}
            className={classes.imageStyle}
            alt="Bildfrage"
          />
        </div>
      </CardMedia>
    );
  }

  render() {
    if (!this.props.question || !this.props.question.answers) {
      return null;
    }
    /* eslint-disable */

    return (
      <Card title={this.props.question.text} showAll={this.props.showAll}>
        {this.renderQuestionImage()}
        {this.props.question.answers.filter(a => a && (!!a.text || (!a.text && a.imageUrl)) ).map(answer => <Answer
          answer={answer}
          completed={this.props.completed}
          isSelected={this.state.selectedAnswers.getIn([answer.id])}
          key={answer.id}
          onCheck={this.answerSelectionChanged.bind(this, answer)}
        />)}
      </Card>
    );
        /* eslint-enable */
  }
}

const styles = () => ({
  imageContainer: {
    maxHeight: 380,
    marginBottom: 20,
    marginTop: 10,
    textAlign: 'center',
    backgroundColor: '#f8f8f8',
  },
  imageStyle: {
    maxWidth: '100%',
    maxHeight: 380,
  },
});

Question.propTypes = {
  classes: PropTypes.object.isRequired,
  question: PropTypes.object,
  showAll: PropTypes.bool,
  completed: PropTypes.bool,
  answerSelectionChanged: PropTypes.func,
};

Question.defaultProps = {
  question: null,
  showAll: false,
  completed: false,
  answerSelectionChanged: () => {},
};

export default withStyles(styles)(Question);



// WEBPACK FOOTER //
// ./src/app/components/question_answering/question.js